import React, { Component } from 'react';
import { Form, Button } from 'react-bootstrap';
import ReactGA from 'react-ga';
import { PulseLoader } from 'react-spinners';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { formatCurrency } from '../../../../utils/FormatUtil';
import Input from '../../../../components/Input';
import { isEmail } from '../../../../utils/ValidationUtil';
import operation from '../../../../components/SecurityFactors/config/OperationType';
import SecurityFactors from '../../../../components/SecurityFactors';
import './resume.css';

class Resume extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorEmail: undefined
    };

    this.handleContinueClick = this.handleContinueClick.bind(this);
    this.liquidate = this.liquidate.bind(this);
  }

  componentDidMount() {
    const { getPersonalInfo, getAccounts } = this.props;

    getPersonalInfo();
    getAccounts();
  }

  handleContinueClick(e) {
    e.preventDefault();

    const { timeDeposit, email, getChallenge, montoLimitDap } = this.props;

    if (isEmail(email)) {
      ReactGA.event({
        category: 'Click',
        action: 'Liquidar DAP'
      });
      if (Number(timeDeposit.montoRescate) <= Number(montoLimitDap)) {
        getChallenge(operation.DAP_LIQUIDAR_MENOR_5MM);
      } else {
        getChallenge(operation.DAP_LIQUIDAR_MAYOR_5MM);
      }
    } else {
      this.setState({
        errorEmail: 'Debe indicar un email válido'
      });
    }
  }

  liquidate() {
    const { liquidateTimeDeposit, email, account, timeDeposit } = this.props;

    liquidateTimeDeposit({
      email,
      account,
      id: timeDeposit.numeroDeposito
    });
  }

  render() {
    const {
      email,
      timeDeposit,
      account,
      accounts,
      changeEmail,
      changeAccount,
      challenges,
      isLoading
    } = this.props;

    const { errorEmail } = this.state;

    if (isLoading) {
      return (
        <div className="dap_loader-center">
          <PulseLoader size={20} color="#d64b36" />
        </div>
      );
    }

    if (
      timeDeposit.cuentaDestino &&
      timeDeposit.cuentaDestino.numeroCuenta === 0 &&
      accounts.length === 0
    ) {
      return (
        <div className="dap_info-socio">
          <h4>
            <FontAwesomeIcon icon={faInfoCircle} />
            Estimado socio:
          </h4>
          <p>
            Para realizar la liquidación de un Depósito a Plazo en línea,{' '}
            <b>necesita una cuenta vista activa</b>.
          </p>
          <p>
            <b>Para abrir una cuenta vista</b>, diríjase a cualquiera de
            nuestras oficinas a lo largo del país.
          </p>
          <p>
            Si usted posee una cuenta vista y esta no se encuentra activa,
            contáctenos al
            <b> 600 200 1200</b>.
          </p>
        </div>
      );
    }

    return (
      <React.Fragment>
        <SecurityFactors operation="liquidar" challenges={challenges} onSuccess={this.liquidate} />

        <Input
          label="Email de contacto"
          value={email}
          maxLength={50}
          width="100%"
          helpText="Cambiar el email de contacto no reemplaza los datos de nuestros registros."
          errorText={errorEmail}
          onChange={e => {
            changeEmail(e.target.value);
          }}
          onFocus={() => {
            this.setState({
              errorEmail: undefined
            });
          }}
          onBlur={() => {
            if (!isEmail(email)) {
              this.setState({
                errorEmail: 'Debe indicar un email válido'
              });
            }
          }}
        />
        <p className="informacion">
          <b>Importante:</b>
          <br />
          Si deseas actualizar este email, puedes ingresar a la opción{' '}
          <b>“Editar mis Datos”</b> (debes tener tarjeta de coordenadas){' '}
          <b>o visita una de nuestras oficinas.</b>
        </p>
        {timeDeposit.cuentaDestino &&
          timeDeposit.cuentaDestino.numeroCuenta === 0 && (
            <div>
              <Form.Label>Cuenta de destino</Form.Label>
              <Form.Control
                as="select"
                onChange={e => {
                  changeAccount(e.target.value);
                }}
              >
                <option value="">Seleccione...</option>
                {accounts.map(cuenta => {
                  return (
                    <option key={cuenta.id} value={cuenta.id}>
                      {`Nº ${cuenta.id} - ${formatCurrency(
                        cuenta.saldoDisponible
                      )}`}
                    </option>
                  );
                })}
              </Form.Control>
            </div>
          )}
        <Button
          className="dap_btn-primary"
          onClick={this.handleContinueClick}
          disabled={
            errorEmail !== undefined ||
            (account === '' &&
              timeDeposit.cuentaDestino &&
              timeDeposit.cuentaDestino.numeroCuenta === 0)
          }
        >
          Continuar
        </Button>
      </React.Fragment>
    );
  }
}

export default Resume;
